import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>
          <p className="text-sand/90 max-w-2xl">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </div>

      <div className="container py-12">
        {/* Breadcrumb */}
        <div className="mb-8">
          <nav className="text-sm text-neutralText">
            <Link to="/" className="hover:text-wood">
              Home
            </Link>
            <span className="mx-2">/</span>
            <span className="text-wood">Terms and Conditions</span>
          </nav>
        </div>

        <div className="prose max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the services of Sri GDM Interior Industries, you agree to be
            bound by these Terms and Conditions. If you do not agree to these terms, please do not
            use our services.
          </p>

          <h2>2. Services</h2>
          <p>
            Sri GDM Interior Industries provides interior design and execution services, including
            but not limited to:
          </p>
          <ul>
            <li>Modular kitchen design and installation</li>
            <li>Custom furniture and wardrobes</li>
            <li>False ceiling design and installation</li>
            <li>Wall paneling and feature walls</li>
            <li>TV unit design and installation</li>
            <li>Office and commercial interior solutions</li>
          </ul>

          <h2>3. Project Execution</h2>
          <h3>3.1 Quotations and Estimates</h3>
          <p>
            All quotations provided are valid for 30 days from the date of issue. Prices may be
            subject to change based on material costs and project modifications.
          </p>

          <h3>3.2 Timeline</h3>
          <p>
            Project timelines are estimated based on scope and complexity. While we strive to meet
            agreed deadlines, circumstances beyond our control may affect completion dates.
          </p>

          <h3>3.3 Changes and Modifications</h3>
          <p>
            Any changes to the approved design or scope of work must be agreed upon in writing and
            may incur additional charges.
          </p>

          <h2>4. Payment Terms</h2>
          <p>Payment terms will be as agreed upon signing of the contract.</p>

          <h2>5. Warranty</h2>
          <p>
            We provide a 1-year warranty on workmanship and materials used in our projects, subject
            to proper usage and maintenance. This warranty does not cover:
          </p>
          <ul>
            <li>Normal wear and tear</li>
            <li>Damage due to misuse or negligence</li>
            <li>Unauthorized modifications</li>
            <li>Natural variations in wood grain or color</li>
          </ul>

          <h2>6. Intellectual Property</h2>
          <p>
            All designs, drawings, and concepts created by Sri GDM Interior Industries remain our
            intellectual property. We reserve the right to use project photographs for marketing
            purposes.
          </p>

          <h2>7. Liability</h2>
          <p>Our liability is limited to the value of the contract. We are not responsible for:</p>
          <ul>
            <li>Consequential damages</li>
            <li>Delays due to force majeure</li>
            <li>Pre-existing structural issues</li>
            <li>Third-party damages</li>
          </ul>

          <h2>8. Cancellation</h2>
          <p>
            Project cancellation must be communicated in writing. Cancellation charges may apply
            based on work completed and materials ordered.
          </p>

          <h2>9. Dispute Resolution</h2>
          <p>
            Any disputes shall be resolved through mutual discussion and negotiation. If necessary,
            legal proceedings shall be conducted under Valliyur jurisdiction.
          </p>

          <h2>10. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Changes will be effective
            immediately upon posting on our website.
          </p>

          <h2>Contact Information</h2>
          <p>For questions about these terms, please contact us at:</p>
          <address className="not-italic">
            Sri GDM Interior Industries
            <br />
            187 H, Kandigaiperi Rd
            <br />
            Valliyur, Tamil Nadu 627117
            <br />
            Phone: +91 98420 84477
            <br />
            Email: info@srigdminteriors.com
          </address>
        </div>
      </div>
    </div>
  );
}
